import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';

import ChipInput from './Chip';
import TextInput from './Text';
import TextMaskInput from './TextMask';

const Input = (props) => {
  const { type, inputProps = {}, ...others } = props;
  let customProps = { ...inputProps, ...others };
  if (inputProps.formProps) {
    customProps = {
      value: get(inputProps, `formProps.values.${inputProps.name}`, ''),
      errorText: get(inputProps, `formProps.errors.${inputProps.name}`, ''),
      touched: get(inputProps, `formProps.touched.${inputProps.name}`, ''),
      onBlur: get(inputProps, 'formProps.handleBlur'),
      // eslint-disable-next-line no-nested-ternary
      onChange: get(inputProps, 'formProps.handleChange'),
      ...inputProps,
    };
  }
  if (type === 'text') {
    return <TextInput {...customProps} />;
  }
  if (type === 'mask') {
    return <TextMaskInput {...customProps} />;
  }
  if (type === 'chip') {
    return <ChipInput {...customProps} />;
  }
  return <></>;
};

Input.propTypes = {
  type: PropTypes.string.isRequired,
  inputProps: PropTypes.object.isRequired,
};

export default Input;
